function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 392.53 392.53",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M329.404,226.586l3.685-51.329c-37.689-19.717-85.915-15.321-125.931,11.507v152.372 c36.331-12.154,78.739-4.461,112.743,20.17c1.422-19.717,4.396-61.285,4.396-61.285c-11.184-5.947-18.877-17.778-18.877-31.354 v-6.465C305.421,244.558,315.441,231.37,329.404,226.586z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M59.376,175.257l3.685,51.329c13.899,4.784,23.984,18.036,23.984,33.552v6.465 c0,13.576-7.628,25.406-18.877,31.354v0.388c1.487,20.299,2.909,40.663,4.396,60.962c34.004-24.63,76.477-32.194,112.743-20.17 V186.828C145.227,159.935,97,155.539,59.376,175.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M306.972,233.503l3.168-44.283c-12.154-5.56-51.394-10.925-81.261,9.826v113.39 c20.558-3.62,51.717,1.616,71.628,11.184c0.646-8.339,2.651-36.008,2.651-36.008"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M196.233,136.21c37.56,0,68.137-30.578,68.137-68.137S233.792,0,196.233,0 s-68.137,30.578-68.137,68.137S158.673,136.21,196.233,136.21z M196.233,21.786c25.6,0,46.352,20.816,46.352,46.352 s-20.816,46.352-46.352,46.352s-46.352-20.816-46.352-46.352S170.633,21.786,196.233,21.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M196.233,21.786c-25.6,0-46.352,20.816-46.352,46.352s20.816,46.352,46.352,46.352 s46.352-20.816,46.352-46.352S221.833,21.786,196.233,21.786z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M359.724,280.307v-34.004h-18.747c-7.564,0-13.77,6.206-13.77,13.77v6.465 c0,7.564,6.206,13.77,13.77,13.77H359.724L359.724,280.307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M65.194,266.602v-6.465c0-7.564-6.206-13.77-13.77-13.77H32.742v34.004h18.747 C59.053,280.307,65.194,274.166,65.194,266.602z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M359.724,224.517h-8.339l3.943-54.626c0.323-4.073-1.681-7.952-5.236-10.15 c-45.382-27.539-104.921-24.113-153.923,8.145c-48.937-32.194-108.541-35.62-153.923-8.145c-3.491,2.069-5.495,6.012-5.236,10.15 l3.943,54.626h-8.21c-12.024,0-21.786,9.826-21.786,21.786v34.004c0,12.024,9.826,21.786,21.786,21.786h13.834 c1.939,26.764,3.879,53.398,5.818,80.162c0.517,8.145,10.99,14.287,18.554,6.982c33.939-33.745,83.329-43.636,120.178-23.984 c4.008,1.616,7.37,1.422,10.279,0c36.848-19.717,86.303-9.826,120.178,23.984c7.499,7.758,18.618,0.323,18.554-6.982 c1.875-26.764,3.879-53.398,5.818-80.162h13.834c12.024,0,21.786-9.826,21.786-21.786v-34.004 C381.509,234.343,371.813,224.517,359.724,224.517z M65.194,266.602c0,7.564-6.206,13.77-13.77,13.77H32.742v-34.004h18.747 c7.564,0,13.77,6.206,13.77,13.77v6.465L65.194,266.602L65.194,266.602z M185.307,339.135 c-36.331-12.154-78.739-4.461-112.743,20.17c-1.487-20.299-2.909-40.663-4.396-60.962v-0.388 c11.184-5.947,18.877-17.778,18.877-31.354v-6.465c0-15.515-10.02-28.768-23.984-33.551l-3.685-51.329 c37.689-19.717,85.915-15.321,125.931,11.572V339.135z M319.901,359.305c-34.004-24.63-76.412-32.323-112.743-20.17V274.23h21.463 c6.012,0,10.925-4.848,10.925-10.925c0-6.077-4.848-10.925-10.925-10.925h-21.463v-19.717h47.838 c6.012,0,10.925-4.848,10.925-10.925c0-6.012-4.849-10.925-10.925-10.925h-47.774v-24.113 c40.081-26.893,88.307-31.289,125.931-11.507l-3.685,51.329c-13.899,4.784-23.984,18.036-23.984,33.551v6.465 c0,13.576,7.628,25.341,18.877,31.354C324.362,297.956,321.324,339.523,319.901,359.305z M340.976,280.307 c-7.564,0-13.77-6.206-13.77-13.77v-6.465c0-7.564,6.206-13.77,13.77-13.77h18.747v34.004H340.976L340.976,280.307z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/UserAvatar.305c6ede36d6e9c94fc148ceac157c20.svg";
export { ForwardRef as ReactComponent };